// Shared between the admin event forms (category picker) and the public
// Events page (filter buttons, card accent colour and eyebrow tag) so both
// stay in sync with a single source of truth.
export const eventCategories = [
  { value: "ai-automation", label: "AI & Automation", color: "violet" },
  { value: "product", label: "Product", color: "gold" },
  { value: "careers", label: "Careers", color: "coral" },
  { value: "leadership", label: "Leadership", color: "blue" },
  { value: "community", label: "Community", color: "green" },
  { value: "data-security", label: "Data & Security", color: "sky" },
];

export const getEventCategory = (value) =>
  eventCategories.find((category) => category.value === value);
